import React from 'react';
import './BlogPreview.css';
import Fade from 'react-reveal/Fade';
import { FaBookOpen } from 'react-icons/fa';

const BlogPreview = ({ onViewBlogDetail }) => {
    return (
        <div className="blog-preview-section" id="blog">
            <div className="container">
                <Fade bottom>
                    <div className="section-header text-center mb-5">
                        <h1 className="section-title">
                            My <span className="gradient-text">Featured Story</span>
                        </h1>
                        <p className="section-subtitle">A glimpse into my journey</p>
                    </div>
                </Fade>

                <Fade bottom>
                    <div className="blog-preview-card">
                        <div className="blog-preview-content">
                            <span className="blog-category">Case Study</span>
                            <h3 className="blog-preview-title">From a Web Development Internship to Building a Full-Fledged Gaming Platform</h3>
                            <p className="blog-preview-excerpt">
                                Every product has a story. Some are smooth. Some are chaotic. Some completely change the people who build them. This is the story behind Knowledge Bubble—and my journey from intern to Technical Lead.
                            </p>
                            <button className="btn btn-hire mt-4" onClick={onViewBlogDetail}>
                                <FaBookOpen className="me-2" /> Read Full Story
                            </button>
                        </div>
                        <div className="blog-preview-image">
                            <img src="kb-logo.png" alt="Knowledge Bubble Story" />
                        </div>
                    </div>
                </Fade>
            </div>
        </div>
    );
};

export default BlogPreview;
